import { updateClient } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";
import { useMutation } from "react-query";

export const useUpdateClient = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation((data) => updateClient(data), {
    onError: (_, variables, context) => {
      showToast({
        message: "Whoops! Something went wrong",
        errorState: true,
        retryHandler: () => mutate(variables, context),
      });
      onError();
    },
    ...otherOptions,
  });

  return {
    updateClientMutation: mutate,
    isLoadingUpdateClient: isLoading,
    ...rest,
  };
};
